const AUTH_STORAGE_KEYS = [
  'token',
  'refreshToken',
  'username',
  'firstName',
  'mustChangePassword',
  // No longer written; older sessions still hold them, so logout keeps clearing them.
  'userGroups',
  'isSuperuser',
  'userRole',
] as const;

export type AuthProfile = {
  email?: string;
  first_name?: string;
  must_change_password?: boolean;
};

function getStorage() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage;
}

export function getToken(): string {
  return getStorage()?.getItem('token') || '';
}

export function getRefreshToken(): string {
  return getStorage()?.getItem('refreshToken') || '';
}

export function isAuthenticated(): boolean {
  return Boolean(getToken() || getRefreshToken());
}

export function getFirstName(): string {
  return getStorage()?.getItem('firstName') || '';
}

/** True while the account still owes the forced password change (from auth/me). */
export function mustChangePassword(): boolean {
  return getStorage()?.getItem('mustChangePassword') === 'true';
}

export function setMustChangePassword(value: boolean) {
  getStorage()?.setItem('mustChangePassword', String(Boolean(value)));
}

export function setAccessToken(token: string) {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  storage.setItem('token', token);
}

export function setRefreshToken(refreshToken: string) {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  storage.setItem('refreshToken', refreshToken);
}

export function setTokenSession(token: string, username: string, refreshToken?: string) {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  storage.setItem('token', token);
  storage.setItem('username', username);
  if (refreshToken) {
    storage.setItem('refreshToken', refreshToken);
  }
}

export function setProfileSession(profile: AuthProfile) {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  storage.setItem('firstName', profile.first_name || '');
  storage.setItem('mustChangePassword', String(Boolean(profile.must_change_password)));
}

export function clearAuth(): void {
  const storage = getStorage();
  if (!storage) {
    return;
  }
  AUTH_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
}
